import { Box, createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        height: '44px!important',
        fontSize: 14,
        background: '#0e1319',
        borderRadius: 8,
      },

      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        color: '#c2ccd8',

        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },

      '& .MuiSelect-icon svg path': {
        fill: '#3e8bff',
      },

      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '20px',
      },

      '& .MuiSelect-iconOpen': {
        top: '0',
        right: '13px',
      },
    },

    heading: {
      position: 'relative',
      borderBottom: '1px solid #2d343e',
      alignItems: 'center',
      paddingBottom: 20,
      marginBottom: 20,

      '&::before': {
        content: '""',
        background: '#3e8bff',
        height: '1px',
        position: 'absolute',
        width: 42,
        bottom: '-1px',
      },
    },

    noLabelFix: {
      marginTop: -10,
    },

    twoColumn: {
      '& > div': {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 5,
        flexWrap: 'wrap',
      },
    },

    textBlock: {
      marginTop: 20,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 20,
      '& > p:first-child': {
        marginBottom: 10,
      },
    },

    yellow: {
      color: theme.palette.type === 'dark' ? '#f7bc02' : '#b58600',
    },

    textLabel: {
      fontWeight: 600,
      letterSpacing: 0.4,
    },

    mediaList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      // '& > p': {
      //   display: 'flex',
      //   alignItems: 'center',
      //   '&:before': {
      //     content: '"○"',
      //     lineHeight: 1,
      //     color: theme.palette.type === 'dark' ? '#f7bc02' : '#b58600',
      //     width: 14,
      //     height: 'auto',
      //     fontSize: 24,
      //     margin: '0 10px 2px 0',
      //   },
      // },
    },

    fileList: {
      display: 'flex',
      gap: '1em',
      marginTop: 10,
      flexWrap: 'wrap',
      textAlign: 'justify',
    },

    img: {
      maxHeight: 144,
      minWidth: 50,
      minHeight: 144,
      margin: '0 10px 10px 0',
      borderRadius: 8,
      cursor: 'pointer',
      transition: '0.2s',

      '&:hover': {
        opacity: 0.8,
      },
    },

    fileItem: {
      background: theme.palette.type === 'dark' ? '#1f2733' : COLORS.LIGHT_BORDER,
      maxWidth: 200,
      height: 46,
      borderRadius: 8,
      display: 'flex',
      padding: '10px 15px',
      [theme.breakpoints.down(960)]: {
        width: '100%',
        maxWidth: 'unset',
        textAlign: 'left',
      },

      '& .MuiSvgIcon-root': {
        fontSize: 20,
        marginRight: 7,

        '& svg path': {
          fill: '#3e8bff',
        },
      },
    },
  }),
);

export const FileName = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));

export const RoleVideoWrapper = styled(Box)(({ theme }) => ({
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
    zIndex: 1200,
  },
  display: 'flex',
  flexDirection: 'column',
}));

export const VideoCont = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 132,
  marginRight: 15,
  marginTop: 10,
  minWidth: 200,
  maxWidth: 200,
  borderRadius: 8,
  float: 'left',
  marginLeft: 10,
  marginBottom: 5,
  [theme.breakpoints.down(960)]: {
    float: 'unset',
    margin: 10,
    minWidth: 'calc(100% - 10px)',
    maxWidth: 'calc(100% - 10px)',
  },
}));

export const VideoMainCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginBottom: 20,
}));

// New Styled
export const TextGreyColor = styled(Typography)(({ theme, size, weight }: any) => ({
  fontSize: size || 16,
  color: '#98a1ac',
  fontWeight: weight || undefined,
}));

export const TextSwitchColor = styled(Typography)(({ theme, size, weight }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  fontWeight: weight || undefined,
}));
